import { getAPIClient } from "./baseCliente";

export const api = getAPIClient();